module.exports = __webpack_public_path__ + "img/1_012.a8e08bb6.jpg";